import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-order-notify-modal',
  templateUrl: './order-notify-modal.component.html',
  styleUrl: './order-notify-modal.component.scss',
})
export class OrderNotifyModalComponent {
  data: any;
  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private router: Router,
  ) {
    this.data = config.data.order;
  }

  goToOrder() {
    this.ref.close('close');
    this.router.navigate([`/order/view-order/${this.data.orderId}`]);
  }
}
